import { GridRowData } from '@material-ui/data-grid';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { TableColumn } from '.';
import Skeleton from '@material-ui/lab/Skeleton';

export type TableHookProps = {
    initialSelectionModal?: any;
    initialFilterType?: string | null;
    initialFilterData?: any;
    columns?: TableColumn[];
    rows?: GridRowData[];
    loading?: boolean;
};

export function useTableWithCollapse<T>({
    initialSelectionModal = [],
    initialFilterType = null,
    initialFilterData = {},
    rows = [],
    columns = [],
    loading,
}: TableHookProps) {
    const [selectedRows, setSelectedRows] = useState<T>(initialSelectionModal);
    const [filterType, setFilterType] = useState<string | null>(null);
    const [filteredData, setFilteredData] = useState<any>({});

    const resetTable = useCallback(() => {
        setSelectedRows(initialSelectionModal);
    }, [initialSelectionModal]);

    const resetFilters = useCallback(() => {
        setFilterType(initialFilterType);
        setFilteredData(initialFilterData);
    }, [initialFilterType, initialFilterData]);

    const tableColumns = useMemo(() => {
        return loading ? columns.map((column) => ({ ...column, Cell: <Skeleton /> })) : columns;
    }, [columns, loading]);

    const tableRows = useMemo(() => {
        return loading ? new Array(5).fill({}) : rows;
    }, [rows, loading]);

    return {
        selectedRows,
        setSelectedRows,
        resetTable,
        resetFilters,
        filterType,
        filteredData,
        setFilterType,
        setFilteredData,
        tableColumns,
        tableRows,
    };
}
